import React from 'react'

const Footer = (props) => {
  return (
    <div className='FooterRoot'>
        {props.children}
    </div>
  )
}

export default Footer